import * as actionTypes from "./profileActions";
import { updateObject } from "../../shared/utility";

const initialState = {
    error: null,
    errorMessage: null,
    loading: false,
    profile: null
};

const profileLoadFinished = (state, action) => {
    return updateObject(
        state,
        {
            loading: false,
            profile: action.payload
        }
    );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.PROFILE_LOAD_FINISH: return profileLoadFinished(state, action);
        default:
            return state;
    }
};

export default reducer;